var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBrowsersSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3131 6.33984H4.06311C3.71793 6.33984 3.43811 6.61967 3.43811 6.96484V15.7148C3.43811 16.06 3.71793 16.3398 4.06311 16.3398H15.3131C15.6583 16.3398 15.9381 16.06 15.9381 15.7148V6.96484C15.9381 6.61967 15.6583 6.33984 15.3131 6.33984Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93811 3.83984H17.8131C17.9789 3.83984 18.1378 3.90569 18.2551 4.0229C18.3723 4.14011 18.4381 4.29908 18.4381 4.46484V13.8398",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowsersSimple);
export default __webpack_public_path__ + "static/media/BrowsersSimple.b7dddeb5abe733bcf1e04e6fdf0fb11e.svg";
export { ForwardRef as ReactComponent };